import {Mesh, PlaneGeometry, Vector3} from "three";
import {boundingBoxMaterial, lineMaterial} from "../../constants/materialConstants";

export class Line {
    constructor(startPoint, endPoint, width, material = lineMaterial) {
        let geometry = new LineGeometry(startPoint, endPoint, width);
        let mesh = new Mesh(geometry, material);
        mesh.position.copy(startPoint.add(new Vector3().subVectors(endPoint, startPoint).multiplyScalar(0.5)));
        return mesh;
    }
}

export class LineGeometry {
    constructor(startPoint, endPoint, width) {
        //Create Line positioned in middle between start and end point
        let geometry = new PlaneGeometry(new Vector3().subVectors(endPoint, startPoint).length(), width);
        geometry.rotateX(-Math.PI / 2);
        return geometry;
    }
}

export function addBoundingBoxToLine(mesh, startPoint, endPoint, width) {
    width *= 6;
    let geometry = new PlaneGeometry(new Vector3().subVectors(endPoint, startPoint).length(), width);
    geometry.rotateX(-Math.PI / 2);
    let bbox = new Mesh(geometry, boundingBoxMaterial);
    bbox.name = "roomLineMeshBBox";
    bbox.visible = false;
    mesh.addWithUuid(bbox);
}
